
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gov",
      function () {
        return require("private-next-pages/gov.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gov"])
      });
    }
  